<template>
  <path
    d="M5.58 16.8902L11.35 12.8202C11.91 12.4202 11.91 11.5802 11.35 11.1902L5.58 7.1102C4.91 6.6502 4 7.1202 4 7.9302V16.0702C4 16.8802 4.91 17.3502 5.58 16.8902ZM13 7.9302V16.0702C13 16.8802 13.91 17.3502 14.58 16.8902L20.35 12.8202C20.91 12.4202 20.91 11.5802 20.35 11.1902L14.58 7.1202C13.91 6.6502 13 7.1202 13 7.9302Z"
  />
</template>
